import React from 'react'
import { Modal } from './Modal'
import { Col, Container, Modal as BootstrapModal, Row } from 'react-bootstrap'
import { Button } from '../Button/Button'

export interface UnsavedChangesModalProps {
  show: boolean
  onHide: () => void
  onSave: () => void
  onDiscard: () => void
  title?: string
  message?: string
  saveDisabled?: boolean
  hideSave?: boolean
  loading?: boolean
}

export const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  show,
  onHide,
  onSave,
  onDiscard,
  title = 'Save changes before leaving',
  message = 'Your changes will be lost if you leave now.',
  saveDisabled,
  hideSave,
  loading,
}) => {
  return (
    <Modal
      header={<BootstrapModal.Title>{title}</BootstrapModal.Title>}
      body={
        <Container>
          <Row>
            <Col>{message}</Col>
          </Row>
        </Container>
      }
      footer={
        <Container>
          <div className='d-flex justify-content-end'>
            <Row className='d-flex gap-3'>
              <Button variant='secondary' onClick={onDiscard} disabled={loading}>
                Discard changes
              </Button>
              {hideSave ? null : (
                <Button variant='primary' onClick={onSave} loading={loading} disabled={saveDisabled}>
                  Save changes
                </Button>
              )}
            </Row>
          </div>
        </Container>
      }
      centered={true}
      show={show}
      onHide={onHide}
    />
  )
}
